import { Point } from "highcharts";
import { NormalizedWidgetAggregatedCost } from "@/services/cloudchipr.api";
import { money } from "@/utils/numeral/money";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";
import {
  normalizedCostWidgetActualCostColor,
  normalizedCostWidgetNormalizedLineColor,
} from "@/components/pages/dashboard/components/widgets/normalized-cost-widget/utils/helpers/generateHighChartsDataForNormalizedCostWidget";

type NormalizedDataMap = Map<string, NormalizedWidgetAggregatedCost[]>;

export const getNormalizedCostWidgetTooltipValueFormatter = (
  dataMap: NormalizedDataMap,
) => {
  return (point: Point) => {
    const costBasedData = dataMap?.get(point.series.name);
    const value = costBasedData?.[point.index];

    const prefix = (value?.trend ?? 0) > 0 ? "+" : "";

    const isUp = (value?.trend ?? 0) > 0;
    const iconSvg = isUp
      ? `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 16 16" fill="red" style="display:inline-block;vertical-align:middle;margin-right:2px;margin-bottom:5px;"><path d="M7 14l5-5 5 5z"/></svg>`
      : `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 16 16" fill="green" style="display:inline-block;vertical-align:middle;margin-right:2px;margin-bottom:7px;"><path d="M7 10l5 5 5-5z"/></svg>`;

    const chartType = point?.series?.chart?.options?.chart?.type;
    const actualCost = dataMap.get("Actual Cost")?.[point.index];
    const normalizedCost = dataMap.get("Normalized Cost")?.[point.index];

    return `
    <div style="font-size: 13px; color: #666; margin-bottom: 8px">
      ${formatDate(String(point.category), { type: "monthNameYear" })}
    </div>

    <div style="display: flex; flex-direction: column; gap: 8px">
      ${
        chartType !== "line"
          ? `
      <div style="display: flex; justify-content: space-between; align-items: center">
        <span
          style="
            display: flex;
            align-items: center;
            font-size: 11px;
            margin-right: 16px;
          "
        >
          <span
            style="font-weight: 500; font-size: 13px; width:${point.series.name.length * 10}px; max-width: 250px; min-width: 35px; word-break: break-word; white-space: normal; padding-left: 8px; border-left: 3px ${point.series.name === "Normalized Cost" ? "dashed" : "solid"} ${point.series.color}"
          >
            ${point.series.name}
          </span>
        </span>
        
        <div
          style="display: flex; flex-direction: row; align-items: center"
        >
          <span style="font-weight: bold; font-size: 12px; margin-right: 4px">
            ${money(actualCost?.cost)}
          </span>
          <span style="font-size: 9px; display: flex; align-items: center; gap: 2px;">
            <span style="display: flex; align-items: center; height: 12px;">
              ${iconSvg}
            </span> 
            ${prefix}${actualCost?.trend ?? 0}%
          </span>
        </div>
      </div>
      `
          : `
            <div style="display: flex; justify-content: space-between; align-items: center">
        <span
          style="
            display: flex;
            align-items: center;
            font-size: 11px;
            margin-right: 16px;
          "
        >
          <span
            style="font-weight: 500; font-size: 13px; width:${"Actual Cost".length * 10}px; max-width: 250px; min-width: 35px; word-break: break-word; white-space: normal; padding-left: 8px; border-left: 3px solid ${normalizedCostWidgetActualCostColor}"
          >
            Actual Cost
          </span>
        </span>
        
        <div
          style="display: flex; flex-direction: row; align-items: center"
        >
          <span style="font-weight: bold; font-size: 12px; margin-right: 4px">
            ${money(value?.cost)}
          </span>
          <span style="font-size: 9px; display: flex; align-items: center; gap: 2px;">
            <span style="display: flex; align-items: center; height: 12px;">
              ${iconSvg}
            </span> 
            ${prefix}${value?.trend ?? 0}%
          </span>
        </div>
      </div>
            <div style="display: flex; justify-content: space-between; align-items: center">
        <span
          style="
            display: flex;
            align-items: center;
            font-size: 11px;
            margin-right: 16px;
          "
        >
          <span
            style="font-weight: 500; font-size: 13px; width:${"Normalized Cost".length * 10}px; max-width: 250px; min-width: 35px; word-break: break-word; white-space: normal; padding-left: 8px; border-left: 3px dashed ${normalizedCostWidgetNormalizedLineColor}"
          >
            Normalized Cost
          </span>
        </span>
        
        <div
          style="display: flex; flex-direction: row; align-items: center"
        >
          <span style="font-weight: bold; font-size: 12px; margin-right: 4px">
            ${money(normalizedCost?.cost)}
          </span>
          <span style="font-size: 9px; display: flex; align-items: center; gap: 2px;">
            <span style="display: flex; align-items: center; height: 12px;">
              ${iconSvg}
            </span> 
            ${prefix}${normalizedCost?.trend ?? 0}%
          </span>
        </div>
      </div>
      `
      }
    </div>
  `;
  };
};
